import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { MenuItem } from 'primeng/api';

import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { AppService, AuthService } from '@core/services';

import { Language, getLocalizedLanguages } from '@/organisations/models';

import { environment } from '@env';

@Component({
    selector: 'app-locale-switch',
    templateUrl: './locale-switch.component.html',
    styleUrls: ['./locale-switch.component.scss'],
    standalone: false,
})
export class LocaleSwitchComponent implements OnInit, OnDestroy {
    @Input() isExtended = false;
    @Input() textClassMini = 'text-primary';
    @Input() options?: { minimized?: boolean; alwaysExtendAfterXL?: boolean; textClassMini?: string };

    localeSubscription?: Subscription;
    currentLocale = Language.NL;
    localizedLanguages = getLocalizedLanguages();
    languageOptions: MenuItem[];
    faCaretDown = faCaretDown;

    internalOptions = { minimized: false, alwaysExtendAfterXL: false, textClassMini: 'text-primary' };

    constructor(private appService: AppService, private authService: AuthService) {
        this.currentLocale = this.appService.getCurrentLocale() as Language;
        this.localeSubscription = this.appService.getLocale().subscribe((locale) => (this.currentLocale = locale as Language));
        this.languageOptions = environment.supportedLocales.map((loc) => {
            return {
                label: this.localizedLanguages[loc as Language],
                command: () => {
                    this.setLanguage(loc as Language);
                },
            };
        });
    }

    ngOnInit() {
        if (this.options !== undefined) {
            Object.assign(this.internalOptions, this.options);
        }
    }

    ngOnDestroy(): void {
        this.localeSubscription?.unsubscribe();
    }

    setLanguage(isoCode: Language) {
        const currentLocale = this.appService.getCurrentLocale() as Language;
        if (isoCode === currentLocale) {
            return;
        }
        this.appService.setLocale(isoCode);
        if (this.appService.getCurrentLocale() === isoCode) {
            const activeUser = this.authService.activeUser.getValue();
            if (activeUser !== undefined && activeUser.locale !== isoCode) {
                this.authService.updateTokenUserLocale(isoCode).subscribe((_) => this.refresh()); //Best effort, no error catch etc
            } else {
                this.refresh();
            }
        }
    }

    private refresh(): void {
        // Show the loading screen to make the reload look smoother
        this.appService.loading.next(true);
        // Reload so we can bootstrap AppComponent with the new locale
        window?.location?.reload();
    }
}
